import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getVerificationDischarge5MasterReferenceData = createAsyncThunk(
  'stop/getVerificationDischarge5MasterReferenceData',
  async (params) => {
    const { url, payload, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .post(url, payload, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const verificationDischarge5MasterReferenceSlice = createSlice({
  name: 'stop/verificationDischarge5MasterReferenceSlice',
  initialState: null,
  reducers: {
    resetVerificationDischarge5MasterReference: () => null,
  },
  extraReducers: {
    [getVerificationDischarge5MasterReferenceData.fulfilled]: (state, action) =>
      action.payload,
  },
});

export const { resetVerificationDischarge5MasterReference } =
  verificationDischarge5MasterReferenceSlice.actions;

export default verificationDischarge5MasterReferenceSlice.reducer;
